const EventEmitter = require('eventemitter3');

const StandardStrike = require('../StandardStrike');
const BattleCalc = require('../../BattleCalc');
const DodgeEvent = require('../../events/DodgeEvent');
const GainAPEvent = require('../../events/GainAPEvent');
const { logError } = require('../../logger');

const MortalStrike = function (battleState) {
  this.handle = 'mortal_strike';
  this.physical = true;
  this.weapon = true;
  this.melee = true;
  this.harm = true;

  this.standardStrike = new StandardStrike(this, battleState);

  this.eventEmitter = new EventEmitter();

  this.isLegal = function (actor, victim) {
    return victim && victim.unit;
  };

  this.execute = function (actor, victim, is_dummy = false) {
    if (!actor || !actor.inPlay || !victim || (victim.unit && !victim.inPlay)) {
      return { success: false };
    }

    try {
      const ability = BattleCalc.getEquippedAbility(actor, this.handle);
      var result;

      if (
        BattleCalc.getCondition(victim, 'stunned') ||
        BattleCalc.getCondition(victim, 'slowed')
      ) {
        result = this.standardStrike.execute(
          actor,
          victim,
          ability.damage,
          false,
          is_dummy
        );

        if (is_dummy) return;

        // if victim killed, refund AP cost
        // (use victim.hp instead of victim.dead because of timeout for DeathEvent)
        if (victim.hp <= 0) {
          var finalPotency = Math.floor(ability.apCost);
          if (finalPotency > actor.max_ap - actor.ap) {
            finalPotency = actor.max_ap - actor.ap;
          }

          const gainAP = new GainAPEvent(battleState, finalPotency);
          gainAP.execute(actor);
          result.gainAPEvent = gainAP;
        }
      } else {
        const dodgeEvent = new DodgeEvent(battleState, victim);
        dodgeEvent.execute();
        result = { dodgeEvent };
      }

      result.abilityHandle = this.handle;
      result.actorId = actor.uid;
      result.victimId = victim ? victim.uid : null;
      result.allPieces = battleState.allPieces;
      this.eventEmitter.emit('result', result);
    } catch (err) {
      logError(err, {
        module: 'MortalStrike',
        func: 'execute',
        actor,
        victim,
      });
      return { success: false };
    }
  };
};
module.exports = MortalStrike;
